import script from "./WorkAndCostCenterView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkAndCostCenterView.vue?vue&type=script&setup=true&lang=ts"

import "./WorkAndCostCenterView.vue?vue&type=style&index=0&id=164ff6ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-164ff6ec"]])

export default __exports__